import { render, staticRenderFns } from "./KarinaSettings.vue?vue&type=template&id=6f06d794&scoped=true&"
import script from "./KarinaSettings.vue?vue&type=script&lang=js&"
export * from "./KarinaSettings.vue?vue&type=script&lang=js&"
import style0 from "./KarinaSettings.vue?vue&type=style&index=0&id=6f06d794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06d794",
  null
  
)

export default component.exports